import { z } from "zod";
import { success } from "@secretaa/http-contract";
export const PATH="/internal/v1/runtime/maintenance/tick";
/** Scheduler carries no tenant, cursor, scope, force flag or execution authority. */
export const Command=z.object({}).strict();
export const Result=z.object({status:z.enum(["DEFERRED","ENQUEUED"]),accepted:z.number().int().min(0).max(100)}).strict().refine(r=>r.status!=="DEFERRED"||r.accepted===0,"DEFERRED_COUNT_INVALID");
export type Result=z.infer<typeof Result>;
export const Response=success(Result);
export const VERSION="1.0.0";
